import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {setPayments} from "../../slice/payments/paymentsSlice";
import {USER_LOCALSTORAGE_KEY} from "../../../../shared/const/localstorage";
import {createRequestParams} from "../../../../common/hook/create-request-params/createRequestParams";


interface PaymentsParams {
    from?: string;
    to?: string;
    page?: number;
}


export const fetchPayments = createAsyncThunk(
    "payments/payments",
    async ({from, to, page }:PaymentsParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);
            const params = createRequestParams(from, to, page);

            const response = await axios.get("/api/payments", {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params,
            });
            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(setPayments(response.data.data));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);